import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { PATH } from '../const/path';
import { DomainService } from '../domain/domain.service';
import { WindowRef } from '../domain/window-ref';
import { AlertErrorDataService } from '../../alert/alert-error/alert-error-data.service';
import { AlertErrorMessage } from '../../alert/alert-error/alert-error-message';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService {

  private readonly auth = inject(AuthService);
  private readonly windowRef = inject(WindowRef);
  private readonly router = inject(Router);
  private readonly alertErrorDataService = inject(AlertErrorDataService);
  private readonly domain = inject(DomainService);

  handleError(error: any) {

    if (error instanceof HttpErrorResponse) {
      if (!this.windowRef.isOnline()) {
        this.router.navigateByUrl(PATH.no_connection);
      } else if (error.status === 401) {
        this.auth.handleUnauthorized();
      } else if (error.status === 403) {
        this.router.navigateByUrl(PATH.forbidden);
      } else if (error.status === 0) {
        console.error(error);
      } else if (error.url && !this.domain.isUrlExcludedFromRetryStrategy(error.url)) {
        this.alertErrorDataService.addAlertMessage(this.alertErrorDataService.alertErrorName, AlertErrorMessage.TYPE.http, error);
      }
      //A client-side or network error occurred.
    } else if (error) {
      console.error(error);
    }
  }
}
